import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewEncapsulation,
} from '@angular/core';
import {UrlBuilderService} from '../../../../services/url-builder.service';
import {ElementExpandEnum} from '../../../../enums/CssClassEnums';
import {ExpandLabelEnum} from '../../../../enums/LabelEnums';
import {WPTag} from '../../../../types/WPTag';
import {WPTagToDisplay} from '../../../../types/WPTagToDisplay';

@Component({
  selector: 'app-blog-taxonomy-box',
  templateUrl: './blog-taxonomy-box.component.html',
  styleUrls: ['./blog-taxonomy-box.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BlogTaxonomyBoxComponent implements OnInit, OnChanges {
  @Input() tags: WPTag[];
  public showExpand = false;
  public filteredTags: WPTagToDisplay[];

  public boxCssClass: string = ElementExpandEnum.NORMAL;
  public buttonLabel: string = ExpandLabelEnum.EXPAND;

  private isExpanded = false;
  private showExpandFrom = 7;

  constructor(private urlBuilder: UrlBuilderService) {}

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {
    this.filterTags();
    this.updateShowExpand();
  }

  toggleExpand(): void {
    this.isExpanded = !this.isExpanded;
    this.updateBoxCssClass();
    this.updateExpandBtnLabel();
  }

  public trackByMethod(i: number, el: WPTag) {
    return el ? el.id : null;
  }

  private getTagUrl(item: WPTag): string[] {
    return this.urlBuilder.CreateBlogTagRouterLink(item.id, item.slug);
  }

  private getTagAnchor(item: WPTag): string {
    return `${item.name} (${item.count})`;
  }

  private updateBoxCssClass(): void {
    this.boxCssClass = this.isExpanded
      ? ElementExpandEnum.EXPANDED
      : ElementExpandEnum.NORMAL;
  }

  private updateExpandBtnLabel(): void {
    this.buttonLabel = this.isExpanded
      ? ExpandLabelEnum.COLLAPSE
      : ExpandLabelEnum.EXPAND;
  }

  private updateShowExpand(): void {
    if (this.filteredTags.length > this.showExpandFrom) {
      this.showExpand = true;
    } else {
      this.showExpand = false;
    }
  }

  private filterTags(): void {
    this.filteredTags = this.tags
      .filter((item) => item.count > 0)
      .map((item) => {
        return {
          ...item,
          anchor: this.getTagAnchor(item),
          routerLink: this.getTagUrl(item),
        };
      });
  }
}
